import "./navbar.scss"
import { useState, useEffect, useRef } from "react"

function Navbar(){
    const [open, setOpen] = useState(false)
    const navRef = useRef(null)

    const closeMenu = () => setOpen(false)

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setOpen(false)
            }
        }
        if (open) {
            document.addEventListener("mousedown", handleClickOutside)
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside)
        }
    }, [open])

    return(
        <header>
        <nav ref={navRef}>
            <a href="#home" className="moi">
                <span className="logo-circle">
                    <img src="/img/icons/logo-philippe.png" className="icon-svg"/>
                </span>
            </a>

            <button className="burger" onClick={() => setOpen(!open)} aria-label="Menu">
                <span className={open ? "bar bar--open" : "bar"}></span>
                <span className={open ? "bar bar--open" : "bar"}></span>
                <span className={open ? "bar bar--open" : "bar"}></span>
            </button>

            <div id="menu" className={open ? "menu--open" : ""}>
                <a className="nav-item" href="#infos" onClick={closeMenu}>À propos</a>
                <a className="nav-item" href="#formations" onClick={closeMenu}>Formations</a>
                <a className="nav-item" href="#exp" onClick={closeMenu}>Expériences</a>
                <a className="nav-item" href="#skills" onClick={closeMenu}>Compétences</a>
                <a className="nav-item" href="#projects" onClick={closeMenu}>Projets</a>
                <a className="nav-item" href="#languages" onClick={closeMenu}>Langues</a>
                <a className="nav-item" href="#other" onClick={closeMenu}>Autres</a>
                <a className="nav-item" href="#contact" onClick={closeMenu}>Contact</a>
            </div>
        </nav>
        </header>
    )
}

export default Navbar
